export const PILLARS = [
  {
    num: "01",
    title: "Expertise & Experience",
    body: "Industry professionals with deep knowledge across IT, healthcare, finance, and beyond.",
  },
  {
    num: "02",
    title: "Tailored Solutions",
    body: "Customised strategies that match your company's culture, goals and hiring needs.",
  },
  {
    num: "03",
    title: "End-to-End Service",
    body: "Comprehensive support — from consultation to post-placement and beyond.",
  },
  {
    num: "04",
    title: "Commitment to Quality",
    body: "Rigorous vetting for skills, qualifications and cultural fit at every stage.",
  },
];

export const VALUES = [
  { title: "Integrity", body: "Honest, transparent communication." },
  { title: "Partnership", body: "Your success is our success." },
  { title: "Excellence", body: "Consistently high-quality service and results." },
  { title: "Innovation", body: "Evolving methods and embracing new technologies." },
];

export const BPO_CORE = [
  "Volume / Bulk Hiring for Voice & Non-Voice",
  "Domestic & International BPO Recruitment",
  "Contract Staffing & Payroll Support",
  "Walk-in & Campus Hiring Management",
  "Entry-Level to Leadership Hiring",
  "Hiring Support for Night / Rotational Shifts",
];

export const BPO_DOMAIN = [
  "Customer Support (Voice / Chat / Email)",
  "Technical Support",
  "Back Office Operations",
  "Collections & Telecalling",
  "Sales & Lead Generation Roles",
  "Multilingual Hiring (Hindi, English, Regional, Foreign Languages)",
];

export const BPO_STRENGTHS = [
  "Large pre-screened candidate database",
  "Quick turnaround time (TAT)",
  "High joining ratio",
  "Experienced BPO recruiters",
  "Verified profiles before submission",
];

export const HIRING_LOCATIONS = [
  "PAN India coverage",
  "Metro & Tier-2 cities",
  "On-site, remote and hybrid hiring",
];

export const TECH_CATEGORIES = [
  {
    id: "software",
    title: "Software Development & Programming",
    tags: [
      "Python", "Java", "JavaScript", "C++", "C#", "TypeScript", "Go", "Rust", "Kotlin", "Swift",
      "React", "Angular", "Node.js", "Django", "Spring Boot", "Flutter", "React Native",
    ],
  },
  {
    id: "cloud",
    title: "Cloud Computing & DevOps",
    tags: [
      "AWS", "Microsoft Azure", "Google Cloud (GCP)", "Kubernetes", "Docker",
      "Terraform", "Ansible", "Jenkins", "GitHub Actions", "GitLab CI/CD", "Infrastructure as Code",
    ],
  },
  {
    id: "ai",
    title: "Artificial Intelligence & Data Science",
    tags: [
      "Machine Learning", "TensorFlow", "PyTorch", "Scikit-learn", "Deep Learning",
      "NLP", "Hadoop", "Spark", "Kafka", "SQL", "MongoDB", "Cassandra",
      "Apache Airflow", "ETL Pipelines",
    ],
  },
  {
    id: "cybersec",
    title: "Cybersecurity",
    tags: [
      "Ethical Hacking", "Penetration Testing", "Network Security", "Cloud Security",
      "IAM", "SIEM",
    ],
  },
  {
    id: "blockchain",
    title: "Blockchain & Web3",
    tags: ["Solidity", "Ethereum", "Smart Contracts", "Hyperledger", "Rust (Solana)", "DeFi", "NFT Development"],
  },
  {
    id: "uiux",
    title: "UI/UX & Web Technologies",
    tags: ["UI/UX Design", "Figma", "Adobe XD", "HTML", "CSS", "JavaScript", "Tailwind CSS", "Progressive Web Apps"],
  },
  {
    id: "network",
    title: "Networking & System Administration",
    tags: ["Linux", "Windows Server", "Network Security", "VPNs", "Firewalls", "Cisco (CCNA / CCNP)", "Palo Alto", "Fortinet"],
  },
  {
    id: "automation",
    title: "Automation & Scripting",
    tags: ["Bash", "PowerShell", "Python Automation", "RPA — UiPath", "Blue Prism", "Automation Anywhere"],
  },
  {
    id: "emerging",
    title: "Emerging Technologies",
    tags: ["IoT (Arduino, Raspberry Pi)", "Edge Computing", "Quantum Computing (Qiskit)", "AR / VR"],
  },
];

export const MARQUEE_TAGS = [
  "Python", "React", "Kubernetes", "AWS", "TensorFlow", "Solidity", "Cybersecurity",
  "Flutter", "Go", "Rust", "GCP", "PyTorch", "NLP", "DevOps", "Web3", "IoT",
  "Figma", "Azure", "Spark", "Quantum", "AR / VR", "Linux", "RPA",
];

export const VALUES_MARQUEE_TAGS = [
  "Integrity", "Partnership", "Excellence", "Innovation",
  "Integrity", "Partnership", "Excellence", "Innovation",
  "Integrity", "Partnership", "Excellence", "Innovation",
];

export const BPO_MARQUEE_TAGS = [
  "Volume Hiring", "Voice Process", "Non-Voice", "Customer Support", "Technical Support",
  "Back Office", "Collections", "Telecalling", "Sales", "Lead Generation",
  "Multilingual", "Hindi", "English", "Foreign Languages", "Walk-in Drives",
  "Campus Hiring", "Night Shift", "Rotational Shift", "Contract Staffing",
  "Payroll Support", "Bulk Hiring", "PAN India", "Tier-2 Cities",
];

export const CONTACT = {
  phone: "+91 63662 38456",
  email: "Info@raprosolutions.com",
  address: "3rd Floor, Lakshmi Complex, Gnana Jyothi Nagar, Ullal Main Road, Bangalore — 560056",
  website: "www.raprosolutions.com",
};

export const HERO_IMAGE = "https://images.unsplash.com/photo-1686100511314-7d4a52987f2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0ZWNoJTIwY29ycG9yYXRlJTIwb2ZmaWNlfGVufDB8fHx8MTc4MjU4NzExMXww&ixlib=rb-4.1.0&q=85";
export const PARTNERSHIP_IMAGE = "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHBhcnRuZXJzaGlwJTIwaGFuZHNoYWtlfGVufDB8fHx8MTc4MjU4NzExMXww&ixlib=rb-4.1.0&q=85";
export const TECH_IMAGE = "https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BlciUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzgyNTg3MTExfDA&ixlib=rb-4.1.0&q=85";
export const TEAM_IMAGE = "https://images.unsplash.com/photo-1549692520-acc6669e2f0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGRldmVsb3BlciUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzgyNTg3MTExfDA&ixlib=rb-4.1.0&q=85";
